import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OrderCheckout } from '@features/user/interfaces/order.interface';
import { OrderService } from '@features/user/services/order.service';
import { UserCheckoutService } from '@features/user/services/user-checkout.service';
import {
  faChevronDown,
  faMoneyCheckAlt,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import { LayoutService } from 'src/app/layout/services/layout.service';

@Component({
  selector: 'fc-user-checkout',
  templateUrl: './user-checkout.component.html',
  styleUrls: ['./user-checkout.component.css'],
})
export class UserCheckoutComponent implements OnInit {
  faMoneyCheckAlt = faMoneyCheckAlt;
  faChevronDown = faChevronDown;
  faSpinner = faSpinner;

  totalItems: number = 0;
  currentPage = 0;
  checkouts: OrderCheckout[] = [] as OrderCheckout[];
  hideLoadMore = true;
  loadMoreLoading = false;
  showLoading: any = false;
  skeleton = true;

  constructor(
    private orderService: OrderService,
    private userCheckoutService: UserCheckoutService,
    private router: Router,
    private layoutService: LayoutService
  ) {
    if (this.layoutService.isMobile$.value) {
      this.layoutService.setFooterVisibility(false);
      this.layoutService.setMobileLayoutConfig({
        headerNav: {
          backButton: true,
          title: 'Checkout',
          searchButton: false,
        },
        bottomNav: {
          visibillity: false,
        },
      });
    }
  }

  ngOnInit(): void {
    this.loadCheckouts();
  }

  ngOnDestroy(): void {
    if (this.layoutService.isMobile$.value) {
      this.layoutService.setFooterVisibility(true);
      this.layoutService.setDefaultMobileLayoutConfig();
    }
  }

  loadCheckouts() {
    this.showLoading = true;
    this.currentPage += 1;
    if (!this.loadMoreLoading) {
      this.loadMoreLoading = true;
      this.orderService.getOrderCheckouts(5, this.currentPage).subscribe(
        (data) => {
          this.totalItems = data.totalItems;
          data.checkouts.forEach((x) => this.checkouts.push(x));
          this.loadMoreLoading = false;
          this.hideLoadMore = false;
          if (this.checkouts.length >= data.totalItems) {
            this.hideLoadMore = true;
          }
          this.showLoading = false;
          this.skeleton = false;
        },
        (error) => {
          this.loadMoreLoading = false;
        }
      );
      this.showLoading = true;
    }
  }

  makePayment(checkout: OrderCheckout) {
    this.router.navigate(['/checkout/manual-transfer', checkout.id]);
    // note: need dynamic payment method
    // const paymentMethod = Number(checkout.payment_method);

    // if (paymentMethod == 1) {
    //   this.router.navigate([
    //     './payment/credit-card',
    //     {
    //       checkoutId: checkout.id,
    //       // tXid: checkout.tXid,
    //       // happyPayTopUpId: resData.happy_pay_top_up_id,
    //     },
    //   ]);
    // } else if (paymentMethod > 1 && paymentMethod <= 11) {
    //   this.router.navigate([
    //     './payment/virtual-account',
    //     {
    //       checkoutId: checkout.id,
    //       paymentMethod: paymentMethod,
    //       // vaccNo: resData.vacc_no,
    //       // happyPayTopUpId: resData.happy_pay_top_up_id
    //     },
    //   ]);
    // } else if (paymentMethod == 21) {
    //   this.router.navigate([
    //     './payment/bank-account/' + checkout.happy_beauty_bank_account_id,
    //     {},
    //   ]);
    // }
  }

  cancelCheckout(id: number) {
    if (confirm('Are you sure want to cancel your checkout?')) {
      this.userCheckoutService.cancelOrderCheckout(id).subscribe((res) => {
        this.checkouts = this.checkouts.filter((x) => x.id != id);
      });
    }
  }
}
